import { Box, Divider, Paper } from '@mui/material'
import { Outlet } from 'react-router-dom'
import HistoryList from '@component/HistoryList'
import Header from './Header'
import Sidebar from './Sidebar'

function Layout () {
  return (
    <Paper className="flex flex-col p-0 w-screen h-screen max-h-screen">
      <Header />
      <Box className="h-0 flex-auto">
        <Box className="flex w-full max-w-full h-full">
          <Sidebar />
          <Box className="flex-1 flex flex-row px-24 py-16 gap-16 overflow-auto max-h-full bg-slate-50">
            <Outlet />
            <Divider orientation="vertical" />
            <HistoryList />
          </Box>
        </Box>
      </Box>
    </Paper>
  )
}

export default Layout
